export default "__VITE_ASSET__DL0$CqtZ__"